module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Plato\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Plato (428−348 BCE) was a philosopher and mathematician in ancient Greece. A student of Socrates and a teacher of Aristotle, his Academy was one of the first institutions of higher learning in the Western world. He is widely regarded as the father of modern philosophy. "), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/WU6oqM/tc-custom/9781504052139.jpg?1705577191850",
      "alt": "This image is the cover for the book Apology"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Apology\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Socrates defends himself in court in this resounding speech, recounted firsthand by one of history’s greatest philosophers.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Plato’s "), _c('i', [_vm._v("Apology ")]), _vm._v("is an account of the speech Socrates makes at the Athenian trial in which he is charged with not accepting the gods recognized by the state, inventing new deities, and corrupting the youth of Athens. Recounted by Plato, Socrates’s speech is a rousing examination of integrity, wisdom, and the role of a philosopher. It is filled with wit, intelligence, and lessons that remain relevant today.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0